import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {EntityKey} from '../../entity/entity';
import {SelectionItem} from '../../selections/selection-item';
import {EntityLineService} from '../../services/entity-line-service';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';

import {FormsModule} from '@angular/forms';

@Component({
    selector: 'lead-time-dialog',
    templateUrl: './lead-time-dialog.component.html',
    styleUrls: ['./lead-time-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatDialogActions, MatButton]
})
export class LeadTimeDialogComponent {
  private readonly entityLineService = inject(EntityLineService);
  readonly dialogRef = inject<MatDialogRef<LeadTimeDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);


  private entityKey: EntityKey;
  public leadTimes: SelectionItem[];
  public selectedLeadTime: string;

  constructor
  () {
    const data = this.data;

    this.leadTimes = data.leadTimes as SelectionItem[];
    this.entityKey = data.entityKey as EntityKey;
    this.selectedLeadTime = this.leadTimes[0].code;
  }

  public saveAndClose(): void {
    this.entityLineService.updateLeadTimes(this.entityKey, this.selectedLeadTime).subscribe(result => {
      this.dialogRef.close(result);
    });
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }

}
